import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useNavigateToAssetOverview } from '~/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';
import { useNavigateToThemeOverview } from '~/hooks/use-navigate-to-theme-overview/useNavigateToThemeOverview';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';

import { CatalystInsightWidget } from './catalyst-insight-widget/CatalystInsightWidget';
import * as S from './CatalystInsightDrawer.styles';

export const CatalystInsightDrawer = () => {
  const { t } = useTranslation(['insights']);
  const { navigateToPage } = useNavigateToAssetOverview();
  const { navigateToTheme } = useNavigateToThemeOverview();

  const { closeDrawer, isOpen, drawerType, entityTag, themeId, insightId } =
    useCatalystDrawer();

  const renderContent = () => {
    if (!insightId) {
      return null;
    }

    switch (drawerType) {
      case 'company':
        return entityTag ? (
          <CatalystInsightWidget
            entityTag={entityTag}
            insightId={insightId}
            type="company"
          />
        ) : null;
      case 'theme':
        return themeId ? (
          <CatalystInsightWidget
            themeId={themeId}
            insightId={insightId}
            type="theme"
          />
        ) : null;
      default:
        return null;
    }
  };

  const handleHeaderButtonClick = () => {
    if (drawerType === 'company' && entityTag) {
      navigateToPage({
        entityTag: entityTag,
      });
    }

    if (drawerType === 'theme' && themeId) {
      navigateToTheme({ themeId: themeId });
    }

    return null;
  };

  return (
    <S.StyledDrawer
      data-testid="catalyst-drawer"
      isOpen={isOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        <Button
          variant="empty"
          label={
            drawerType === 'company'
              ? t('insights:catalyst.viewOnAO')
              : t('insights:catalyst.viewOnTheme')
          }
          iconName="Expand"
          size="xsmall"
          onClick={handleHeaderButtonClick}
        />
      }
    >
      <S.ContentWrapper>
        <ErrorBoundaryWrapper>{renderContent()}</ErrorBoundaryWrapper>
      </S.ContentWrapper>
    </S.StyledDrawer>
  );
};
